class SearchController {
  constructor() {
    this.init();
  }

  init() {
    const _this = this;

    return new Promise((resolve) => {
      this.bindListeners();

      resolve();
    });
  }

  bindListeners() {
    const _this = this;

    $('body').on('select2:select', '.filter--select2', _this.selectFilter.bind(_this));

    document
      .querySelector('body')
      ._addCustomEventListener('submit', '#globalSearch', _this.submitGlobalSearch.bind(_this));

    document.querySelector('body')._addCustomEventListener('click', '.load-more', _this.loadMoreResults.bind(_this));

    document
      .querySelector('body')
      ._addCustomEventListener('click', '.search-box__toggle', _this.toggleSearchButton.bind(_this));

    document
      .querySelector('body')
      ._addCustomEventListener('click', '.js-submit-search-form', _this.submitForm.bind(_this));

    document.querySelector('body')._addCustomEventListener('submit', '.search-box__form', _this.submitForm.bind(_this));
  }

  loadMoreResults(e) {
    e.preventDefault();

    const form = document.querySelector('.search-box form');
    const el = e.targetElement;
    const page = el.getAttribute('data-pg');

    this.page = parseInt(page) + 1;
    this.setUrlParam('pg', this.page);
    this.setUrlParams(form);
    this.prepareAjax(form, true);
    this.doAjax();
  }

  selectFilter(e) {
    const target = e.target ? e.target : e;

    if (target.closest('.filters__container') || target.classList.contains('sort-by')) this.submitForm(e);
    else if (target.closest('.search-box')) {
      const form = target.closest('form');
      this.setUrlParams(form);
      this.prepareAjax(form);
      this.updateAllFilters();
    }
  }

  submitForm(e) {
    e.preventDefault();

    if (this.isGlobalSearchPage()) {
      this.submitGlobalSearch(e, false);
      return false;
    }

    const form =
      e.target.closest('.search-box__form') || e.target.closest('form') || document.querySelector('.search-box__form');

    this.setUrlParams(form);
    this.prepareAjax(form);
    this.doAjax();
  }

  submitGlobalSearch(e, overlay = true) {
    e.preventDefault();

    const form = overlay ? e.target : document.querySelector('.search-box__form');
    let keywords = form.querySelector('[name="s"]').value;
    let url = form.getAttribute('action') + '?s=' + keywords;

    document.querySelectorAll('[name="s"]').forEach((el) => (el.value = keywords));

    if (overlay) searchOverlay.closeSearch();

    if (!this.isGlobalSearchPage()) {
      barba.go(url);
      return false;
    }

    this.setUrlParams(form);
    this.prepareAjax(form);
    this.doAjax();
  }

  setUrlParam(name, val) {
    const url = new URL(window.location.href);
    const params = url.searchParams;

    params.set(name, val);
    this.setHistoryState(url);
  }

  delUrlParam(name) {
    const url = new URL(window.location.href);
    const params = url.searchParams;

    params.delete(name);
    this.setHistoryState(url);
  }

  setUrlParams(form) {
    const url = new URL(window.location.href);
    const params = url.searchParams;
    const paramsRef = Array.from(params.entries());
    const ignoredParams = ['action', 'post_id', 'filters_action', 'template_name'];
    const sortBy = document.querySelector('#sort-by');

    let formData = new FormData(form);

    for (const d of paramsRef) {
      if (d[0] == 'pg' && d[1] !== '1') continue;
      params.delete(d[0]);
    }

    for (const d of formData.entries()) {
      if (ignoredParams.includes(d[0])) continue;
      params.append(d[0], d[1]);
      if (d[1] == '' && d[0] != 's') params.delete(d[0]);
    }

    if (sortBy) params.append(sortBy.name, sortBy.value);

    this.setHistoryState(url);
  }

  getUrlParams(form) {
    const sortBy = document.querySelector('#sort-by');
    let data = '';
    let formData = new FormData(form);

    formData.append('lang', ajax_obj.lang);

    if (sortBy) formData.append(sortBy.name, sortBy.value);

    data += '&' + new URLSearchParams(formData);

    if (this.page) data += '&pg=' + this.page;

    return data;
  }

  setHistoryState(url) {
    history.replaceState(null, '', url.href);
  }

  isGlobalSearchPage() {
    const url = new URL(window.location.href);
    const reg = new RegExp(url.origin + '\\/\\?s?.*');

    return url.href.match(reg);
  }

  prepareAjax(form, paginate = false) {
    this.container = document.querySelector('.filters__section');

    if (!paginate) {
      this.resetPagination();
      this.filter = true;
    }

    this.data = this.getUrlParams(form);
  }

  toggleSearchButton(e) {
    const keywords = e.target.closest('.search-box').querySelector('.search-box__keywords');
    keywords.classList.toggle('search-box__keywords--active');

    if (keywords.classList.contains('search-box__keywords--active')) keywords.querySelector('.search__text').focus();
    else {
      const button = e.target
        .closest('.search-box')
        .querySelector('.search-box__filters')
        .querySelector('.search-box__toggle');
      button.focus();
    }
  }

  toggleAjaxOverlay() {
    const overlayIsActive = document.querySelector('main').classList.contains('load-overlay');

    if (!overlayIsActive) {
      const icon = document.createElement('div');
      icon.classList.add('load-overlay__icon');

      document.querySelector('main').classList.add('load-overlay');
      document.querySelector('body').appendChild(icon);
    } else {
      document.querySelector('.load-overlay').classList.remove('load-overlay');
      document.querySelector('.load-overlay__icon').remove();
    }
  }

  doAjax() {
    const _this = this;

    this.toggleAjaxOverlay();

    fetch(ajaxurl, {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        'Cache-Control': 'no-cache',
      },
      body: _this.data,
    })
      .then((response) => {
        if (!response.ok) {
          this.toggleAjaxOverlay();
          throw Error(response.statusText);
        }
        return response;
      })
      .then((response) => response.text())
      .then((data) => {
        const PARSER = new DOMParser();
        const DOC = PARSER.parseFromString(data, 'text/html');
        const blocks = DOC.querySelectorAll('.filters__block');
        const buttons = DOC.querySelector('.load-more__container');
        const heading = DOC.querySelector('.search__results__heading');

        if (!this.container) {
          const breadcrumbs = document.querySelector('.breadcrumbs__container');
          const newBreadcrumbs = DOC.querySelector('.breadcrumbs__container');
          const results = DOC.querySelector('.filters__section');

          document.querySelector('main')._insertAfter(results, breadcrumbs);

          if (newBreadcrumbs) breadcrumbs.replaceWith(newBreadcrumbs);

          const topContainer = document.querySelector('.filters__section').closest('.container-fluid--gutters');
          let pageEles = topContainer._nextAll('div, section');
          if (pageEles) {
            pageEles.forEach((ele) => {
              ele._remove();
            });
          }
          setTimeout(() => {
            Select2Filters.init();
          }, 10);
        } else {
          // Blocks
          if (_this.filter) _this.container.querySelectorAll('.filters__block')._remove();
          if (blocks.length) _this.container._appendAll(blocks);

          // Buttons
          if (_this.container.querySelector('.load-more__container'))
            _this.container.querySelector('.load-more__container')._remove();
          if (buttons) _this.container._appendAll(buttons);

          // Count
          if (_this.container.querySelector('.search__results__heading')) {
            _this.container.querySelector('.search__results__heading').replaceWith(heading);
            setTimeout(() => {
              Select2Filters.init();
            }, 10);
          }
        }

        _this.resetProps();
        _this.toggleAjaxOverlay();
      })
      .catch((error) => console.error(error));
  }

  updateAllFilters() {
    const _this = this;
    const DATA = new URLSearchParams(this.data);
    let action = DATA.get('filters_action');

    if (action === 'get_global_search') return;

    this.toggleAjaxOverlay();
    DATA.set('action', action);

    fetch(ajaxurl, {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        'Cache-Control': 'no-cache',
      },
      body: DATA,
    })
      .then((response) => {
        if (!response.ok) {
          this.toggleAjaxOverlay();
          throw Error(response.statusText);
        }
        return response;
      })
      .then((response) => response.text())
      .then((data) => {
        const PARSER = new DOMParser();
        const DOC = PARSER.parseFromString(data, 'text/html');
        const fields = DOC.querySelectorAll('.filter__field');

        document.querySelectorAll('.filter__field').forEach((field, index) => {
          field.replaceWith(fields[index]);
        });

        Select2Filters.init()
          .then(PikadayFields.init())
          .then(() => _this.toggleAjaxOverlay());
      })
      .catch((error) => console.error(error));
  }

  resetProps() {
    this.filter = false;
    this.container = false;
  }

  resetPagination() {
    this.page = false;
    this.delUrlParam('pg');
  }
}

document.addEventListener('readystatechange', (event) => {
  if (document.readyState == 'complete') {
    window.SearchController = new SearchController();
  }
});
